import { groq } from 'next-sanity';
import { z } from 'zod';

import { basicText, SanityBasicText } from './basicText';

/** Shape shared by page-builder sections and document-level footnotes fields. */
export const SanityDocumentFootnotes = z.object({
  theme: z.enum(['light', 'charcoal', 'purple']),
  content: SanityBasicText.optional().nullable(),
});
export type SanityDocumentFootnotes = z.infer<typeof SanityDocumentFootnotes>;

export const SanityFootnotes = SanityDocumentFootnotes.extend({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('footnotes'),
  _key: z.string(),
  content: SanityBasicText,
});
export type SanityFootnotes = z.infer<typeof SanityFootnotes>;

export const documentFootnotes = groq`{
  "theme": coalesce(theme, "light"),
  content[] ${basicText},
}`;

export const footnotes = groq`{
  _type,
  _key,
  "theme": coalesce(theme, "light"),
  content[] ${basicText},
}`;
